import {
  DELETE_LOCATION,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_LOCATION:
      return { ...state, loading: true };
    case DELETE_LOCATION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_LOCATION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteLocationReducer;
